import parseQuery from './parseQuery';

export default parseQuery;
